import joinourdrive from '../../assets/Join_our_drive.png'
import applyforinternship from '../../assets/Apply_for_internship.png'

const App = () => {
  return(
    
    <div className='w-full min-h-[452px] px-4 sm:px-6 lg:px-[60px] py-[32px] bg-[#FEF7ED]'>
          
          <div className='max-w-[1200px] mx-auto text-center'>
            <h2 className='text-[20px] sm:text-[24px] font-medium font-poppins'>
              Join Us
            </h2>
            <p className="mt-2 text-[14px] sm:text-[16px] font-inter">
              Be part of meaningful change. Whether you want to volunteer in our community drives or gain valuable experience through our internship program, there's a place for you.
            </p>
          </div>

          <div className='w-full flex flex-col lg:flex-row gap-[24px] justify-center mt-8'>
            
            
            <div className='flex flex-col items-center w-full max-w-[524px] bg-[#EB5A57] rounded-2xl mx-auto'>
              <img src={joinourdrive} alt="Join_our_drive" className='w-[40px] h-[40px] mt-5' />
              
              <h1 className='mt-2 font-medium text-[20px] sm:text-[24px] text-center text-white'>
                Join Our Drive
              </h1>
              
              <p className="m-4 font-medium text-[14px] sm:text-[16px] text-[#FFFFFF80] text-center">
                Volunteer with us in impactful community initiatives. From tree plantation drives to food distribution, health camps to educational programs — your time and effort can create lasting change in the lives of those who need it most.
              </p>
              
              <button className='mt-auto mb-6 text-white w-[90%] sm:w-[500px] rounded-[8px] h-[40px] bg-black'>
                Join Our Drives
              </button>
            </div>

            
            <div className='flex flex-col items-center w-full max-w-[524px] bg-[#EB5A57] rounded-2xl mx-auto'>
              <img src={applyforinternship} alt="Apply_for_internship" className='w-[40px] h-[40px] mt-5' />
              
              <h1 className='mt-2 font-medium text-[20px] sm:text-[24px] text-center text-white'>
                Apply for Internship
              </h1>
              
              <p className="m-4 font-medium text-[14px] sm:text-[16px] text-[#FFFFFF80] text-center">
                Gain hands-on experience in the nonprofit sector while making a real difference. Work alongside our team on education programs, community outreach, digital marketing, and more. Build your skills while building a better tomorrow.
              </p>
              
              <button className='mt-auto mb-6 text-white w-[90%] sm:w-[500px] rounded-[8px] h-[40px] bg-black'>
                Apply Now
              </button>  
            </div>

          </div>
          
    </div>
    
  )
}

export default App
